import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { billingKeys } from "@/lib/query-keys";
import { useMySubscription } from "@/hooks/queries/useMySubscription";
import type { BillingPlan } from "@/types/domain";

/** Planes públicos de la tabla de precios, ya ordenados por el backend. */
export function useBillingPlans(enabled = true) {
  return useQuery({
    queryKey: billingKeys.plans(),
    enabled,
    queryFn: () => fetchToBackend<BillingPlan[]>("/subscriptions/plans"),
  });
}

/**
 * El plan que se ofrece cuando el usuario topa con un límite. Es el tier más alto
 * por encima del suyo, no el siguiente: los modales empujan al que resuelve el
 * problema de una vez. `null` si ya está arriba de todo.
 */
export function useUpgradePlan(enabled = true) {
  const { data: plans } = useBillingPlans(enabled);
  const { data: subscription } = useMySubscription(enabled);

  if (!plans?.length) return null;
  const currentOrder =
    plans.find((plan) => plan.plan_id === subscription?.planId)?.plan_order ??
    -1;
  // Solo se propone un plan que el usuario pueda contratar solo. CORPORATIVO y
  // ASESORIA DE OBRAS se venden por fuera (`plan_priceamount` null) y son los de
  // `plan_order` más alto, así que sin este filtro eran SIEMPRE los propuestos —
  // y a un admin, que además ve los planes ocultos, el upsell le ofrecía un plan
  // interno que no puede comprar desde la app.
  return (
    plans
      .filter(
        (plan) =>
          plan.plan_order > currentOrder &&
          plan.plan_priceamount != null &&
          plan.plan_priceamount > 0,
      )
      .at(-1) ?? null
  );
}
